<div class="c-wrapper">
    <div class="c-n-wrapper">
        <span multilang class="producttype">{{sktvContent?.producttype}} ({{sktvContent?.orderId}})</span>
        <span multilang class="ratting">
            <mat-icon class="rico" *ngFor="let cat of sktvContent?.categoryAr;">{{cat === 1 ? 'star':
                'star_half'}}</mat-icon>
        </span>
        <div class="topw">
            <span multilang class="c-title">{{sktvContent?.name}}</span>
            <span multilang class="c-location">{{sktvContent?.location}}</span>
        </div>

        <div class="dg-info-item mt">
            <span multilang [class.dg-info-item-first]="deskMode"
                [class.dg-info-item-first-mobile]="!deskMode">Reisezeitraum:</span>
            <span multilang>{{booking?.commonOffer?.travelDate?.fromDate | date:'dd.MM.yyyy'}} -
                {{booking?.commonOffer?.travelDate?.toDate | date:'dd.MM.yyyy'}}</span>
        </div>
        <div class="dg-info-item">
            <span multilang [class.dg-info-item-first]="deskMode"
                [class.dg-info-item-first-mobile]="!deskMode">Dauer:</span>
            <span multilang>{{booking?.commonOffer?.travelDate?.duration}}
                {{booking?.commonOffer?.travelDate?.duration
                === '1' ?
                'Nacht' : 'Nächte'}}</span>
        </div>
        <div class="dg-info-item">
            <span multilang [class.dg-info-item-first]="deskMode"
                [class.dg-info-item-first-mobile]="!deskMode">Zimmer:</span>
            <span multilang>{{booking?.commonOffer?.hotelOffer?.roomType?.name}}
                {{booking?.commonOffer?.hotelOffer?.locatedList?.join(',')}}
                {{booking?.commonOffer?.hotelOffer?.facilityList?.join(',')}}</span>
        </div>
        <div class="dg-info-item">
            <span multilang [class.dg-info-item-first]="deskMode"
                [class.dg-info-item-first-mobile]="!deskMode">Verpflegung:</span>
            <span multilang>{{booking?.commonOffer?.hotelOffer?.boardType?.name}}</span>
        </div>

        <span multilang class="buch">Buchbar nur bis : {{sktvContent?.online?.last | date}}</span>
    </div>

    <div class="c-block">
        <div class="c-item">
            <span multilang class="c-item-title">Preis</span>
            <div class="offerprice">
                <span multilang class="f400">{{travelerText}}</span>
                <span multilang multilang deeplMode='html' [innerHtml]="prcdetail | safehtml"></span>
                <div class="offerpriceTotal">
                    <span multilang>Gesamtpreis:</span>
                    <span multilang class="prccolor ml">{{booking?.totalPrice?.value | number:'1.2-2'}}
                        {{booking?.totalPrice?.currency}}</span>
                </div>
            </div>
        </div>
    </div>

    <ng-container *ngIf="booking?.extracomment?.length > 0">
        <div class="c-block">
            <div class="c-item">
                <span multilang class="c-item-title">Extra info</span>
                <div class="v-wrapper">
                    <pre class="ml pree">{{booking?.extracomment}}</pre>
                </div>
            </div>
        </div>
    </ng-container>

    <div class="c-block">
        <ng-container *ngIf="sktvContent.advantage?.length > 0">
            <div class="c-item">
                <span multilang class="c-item-title">Veranstalter</span>
                <div class="v-wrapper">
                    <img *ngIf="booking?.commonOffer?.tourOperator?.png?.length > 0"
                        src="{{booking?.commonOffer?.tourOperator?.png}}" class="lazyload" height="24px"
                        alt="{{booking?.commonOffer?.tourOperator?.name}}">
                    <span multilang class="ml">{{booking?.commonOffer?.tourOperator?.name}}
                        ({{booking?.commonOffer?.tourOperator?.code}})</span>
                    <span multilang class="ml ul"><a multilang [href]="booking?.commonOffer?.tourOperator?.agb"
                            target="blank">AGB</a></span>
                </div>
            </div>
        </ng-container>
    </div>

    <div class="c-block">
        <ng-container *ngIf="sktvContent.advantage?.length > 0">
            <div class="c-item">
                <span multilang class="c-item-title">Vorteil</span>
                <div multilang deeplMode='html' [innerHtml]="sktvContent.advantage | safehtml" class="vorteile">
                </div>
            </div>
        </ng-container>
    </div>

    <div class="c-block">
        <ng-container *ngIf="booking?.commonOffer?.flightOffer?.flight?.inbound?.legList?.length > 0">
            <div class="c-item">
                <span multilang class="c-item-title">Flugdetail</span>
                <ng-container *ngIf="deskMode else infomobilemode">
                    <ng-container
                        *ngTemplateOutlet="finfo; context:{flugs: booking.commonOffer.flightOffer.flight.outbound.legList}">
                    </ng-container>
                    <div class="mt">
                        <ng-container
                            *ngTemplateOutlet="finfo context:{flugs: booking.commonOffer.flightOffer.flight.inbound.legList}">
                        </ng-container>
                    </div>
                </ng-container>
            </div>
        </ng-container>
    </div>

    <div class="c-block">
        <ng-container *ngIf="sktvContent.images?.length > 0">
            <div class="c-item">
                <span multilang class="c-item-title">Bilder</span>
                <div class="imgw">
                    <ng-container *ngFor="let im of sktvContent.images;let k=index">
                        <img (click)="openImageModal(k)" *ngIf="im?.length > 0" src="{{im}}"
                            class="lazyload myimg">
                    </ng-container>
                </div>
            </div>
        </ng-container>
    </div>
    <div class="c-block">
        <ng-container *ngIf="sktvContent?.video?.length > 0">
            <div class="c-item">
                <span multilang class="c-item-title">Videos</span>
                <div class="imgw">
                    <ng-container *ngFor="let vd of sktvContent.video;let k=index">
                        <video controls class="myvideo">
                            <source [src]="vd + '#t=0.001'">
                            Your browser does not support HTML video.
                        </video>
                    </ng-container>
                </div>
            </div>
        </ng-container>
    </div>

    <div class="c-block">
        <ng-container *ngIf="sktvContent.advantage?.length > 0">
            <div class="c-item">
                <span multilang class="c-item-title">Leistungen</span>
                <div multilang deeplMode='html' [innerHtml]="sktvContent.description.sktv_content_1 | safehtml"
                    class="vorteile"></div>
            </div>
        </ng-container>
    </div>

    <div class="c-block">
        <ng-container *ngIf="sktvContent.description?.accommodation?.text?.length > 0">
            <div class="c-item">
                <span multilang class="c-item-title">Hotelinformationen</span>
                <div multilang deeplMode='html' [innerHtml]="sktvContent.description.accommodation.text | safehtml"
                    class="vorteile"></div>
                <div multilang deeplMode='html' [innerHtml]="sktvContent.description?.regioninfo?.text | safehtml"
                    class="vorteile"></div>
                <div multilang deeplMode='html' [innerHtml]="sktvContent.description?.notices?.text | safehtml"
                    class="vorteile"></div>
                <div multilang deeplMode='html' [innerHtml]="sktvContent.description?.children?.text | safehtml"
                    class="vorteile"></div>
                <div multilang deeplMode='html' [innerHtml]="sktvContent.description?.leisuretips?.text | safehtml"
                    class="vorteile"></div>
                <div multilang deeplMode='html' [innerHtml]="sktvContent.description?.legalnote?.text | safehtml"
                    class="vorteile"></div>
            </div>
        </ng-container>
    </div>

    <div class="c-block">
        <ng-container *ngIf="sktvContent.description?.itinerary?.text?.length > 0">
            <div class="c-item">
                <span multilang class="c-item-title">Reiseinformationen</span>
                <div multilang deeplMode='html' [innerHtml]="sktvContent.description.itinerary.text | safehtml"
                    class="vorteile"></div>
            </div>
        </ng-container>
    </div>

    <div class="f-btn-wrapper">
        <button class="f-btn colorB" matRipple (click)="sendBooking()">Jetzt buchen</button>
        <button class="f-btn colorA" matRipple (click)="sendAalternative()">Alternative</button>
    </div>
</div>

<ng-template #finfo let-flugs="flugs">
    <ng-container *ngIf="flugs?.length > 0">
        <div class="f-info-wrapper">
            <div class="f-info-a">
                <span multilang>{{flugs[0].departureAirportName}}</span>
                <mat-icon class="f-info-a-icon">flight</mat-icon>
                <span multilang>{{flugs[flugs.length - 1].arrivalAirportName}}</span>
                <span multilang class="f-stopps"><span multilang class="it">Stopps:</span> {{flugs.length -
                    1}}</span>
            </div>
            <ng-container *ngFor="let fl of flugs">
                <div class="f-info-date">
                    <span multilang>{{fl.departureDate | date:'EEE, dd.MM.yyyy'}}</span>
                    <span multilang>{{fl.flightCarrierName}} ({{fl.flightNumber}})</span>
                    <span multilang class="w-20">{{fl.departureAirportName}} ({{fl.departureAirportCode}})</span>
                    <span multilang class="w-20">{{fl.arrivalAirportName}} ({{fl.arrivalAirportCode}})</span>
                    <div class="t-wrapper">
                        <span multilang class="ml">{{fl.departureTime}}</span>
                        <div class="ml a-time">
                            <span multilang>{{fl.arrivalTime}}</span>
                        </div>
                        <div class="ml a-time">
                            <span multilang><span multilang class="it">Dauer:</span>
                                {{fl.estimatedElapsedTime}}</span>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </ng-container>
</ng-template>

<ng-template #infomobilemode>
    <ng-container
        *ngTemplateOutlet="finfoMobile; context:{flugs: booking.commonOffer.flightOffer.flight.outbound.legList}">
    </ng-container>
    <div class="mt">
        <ng-container
            *ngTemplateOutlet="finfoMobile context:{flugs: booking.commonOffer.flightOffer.flight.inbound.legList}">
        </ng-container>
    </div>
</ng-template>


<ng-template #finfoMobile let-flugs="flugs">
    <ng-container *ngIf="flugs?.length > 0">
        <div class="f-info-wrapper">
            <div class="f-info-a">
                <span multilang>{{flugs[0].departureAirportName}}</span>
                <mat-icon class="f-info-a-icon">flight</mat-icon>
                <span multilang>{{flugs[flugs.length - 1].arrivalAirportName}}</span>
                <!--span class="f-stopps"><span  multilang   class="it">Stopps:</span> {{flugs.length - 1}}</span-->
            </div>
            <ng-container *ngFor="let fl of flugs;let k=index">
                <div class="f-info-date-mobile">
                    <div class="f-mobile-info-item-wrapper">
                        <span multilang class="f-mobile-info-item">Von</span>
                        <span multilang>{{fl.departureAirportName}} ({{fl.departureAirportCode}})</span>
                    </div>
                    <div class="f-mobile-info-item-wrapper">
                        <span multilang class="f-mobile-info-item">Nach</span>
                        <span multilang>{{fl.arrivalAirportName}} ({{fl.arrivalAirportCode}})</span>
                    </div>
                    <div class="f-mobile-info-item-wrapper">
                        <span multilang class="f-mobile-info-item">Datum</span>
                        <span multilang>{{fl.departureDate | date:'EEEE, dd.MM.yyyy'}}</span>
                    </div>
                    <div class="f-mobile-info-item-wrapper">
                        <span multilang class="f-mobile-info-item">Flug</span>
                        <span multilang>{{fl.flightCarrierName}} ({{fl.flightNumber}})</span>
                    </div>
                    <div class="f-mobile-info-item-wrapper">
                        <span multilang class="f-mobile-info-item">Abflug</span>
                        <span multilang>{{fl.departureTime}}</span>
                    </div>
                    <div class="f-mobile-info-item-wrapper">
                        <span multilang class="f-mobile-info-item">Ankunft</span>
                        <span multilang>{{fl.arrivalTime}}</span>
                    </div>
                    <div class="f-mobile-info-item-wrapper">
                        <span multilang class="f-mobile-info-item">Dauer</span>
                        <span multilang>{{fl.estimatedElapsedTime}}</span>
                    </div>
                </div>
                <ng-container *ngIf="k < flugs.length -1">
                    <mat-divider class="mb mt"></mat-divider>
                </ng-container>
            </ng-container>
        </div>
    </ng-container>
</ng-template>

<div class="fixedlefttop">
    <button class="f-btn colorA" matRipple (click)="sendAalternative()">Alternative</button>
    <button class="f-b-top" matRipple (click)="sendBooking()">Jetzt buchen</button>
</div>